import PropTypes from "prop-types";
import React from 'react';
import Control from "../Control";
import Dropdown from "../Dropdown/Dropdown";
import Input from "../Input-new/Input";
import Textarea from "../Textarea-new/Textarea";

const VendorForm = ({theme = 'white', data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Vendor' : 'Add Vendor'}</div>
                <Input theme={theme}
                       valueType='text'
                       name='first_name'
                       label='First Name'
                       value={data.first_name}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='last_name'
                       label='Last Name'
                       value={data.last_name}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='company_name'
                       label='Company Name'
                       value={data.company_name}
                       handleParentChange={handleParentChange}
                />
                <Dropdown theme={theme}
                    optionsType='vendorType'
                    value={data.vendor_type}
                    valueKey='vendor_type'
                    label='Vendor Type'
                    data={data}
                    handleParentChange={handleParentDropdownChange}
                />    
                {/* <Dropdown theme={theme}
                          optionsType='profiles'
                          value={data.profile}
                          valueKey='profile'
                          label='Profile'
                          data={data}
                          handleParentChange={handleParentDropdownChange}
                /> */}
                
                {/* {
                    !isFilter &&   
                    // <div className='last-modified'>Last modified on: {data.LAST_MODIFIED}</div>      
                    <div className='last-modified'>Last modified on: {data.last_modified}</div>
                }
                <Textarea theme={theme}
                        name='notes'
                        label='Notes'
                        value={data.notes}
                        maxWidth='100%'
                        handleParentChange={handleParentChange}
                /> */}
            </React.Fragment>
        ),
    ];

    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

VendorForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    data: PropTypes.object.isRequired,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
};

export default VendorForm;